import React from "react";
import clsx from "clsx";

import {withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

import PrimaryButton from "../../../../components/Buttons/PrimaryButton";
import BaseDialog from "../../../../components/BaseDialog/BaseDialog";

import styles from "./styles";


const ConfirmationDialog = (props) => {
  const {
    classes,
    variant='normal',
    customClasses={},
    rejectButtonText,
    confirmButtonText,
  } = props;

  const dialogTitleClass = classes[variant];

  const mergedCustomClasses = {
    ...customClasses,
    dialogTitle: clsx(dialogTitleClass, customClasses.dialogTitle),
  };

  const isDanger = variant === 'danger';

  return (
    <BaseDialog
      title={isDanger ? <><i className={"far fa-exclamation-triangle"}/>{props.title}</> : props.title}
      maxWidth='sm'
      disableBackdropClick
      open={props.open}
      handleClose={props.onCancel}
      modalLoading={props.loading}
      customClasses={mergedCustomClasses}
      actions={
        <Grid container spacing={2} justify={"flex-end"}>
          <Grid item>
            <PrimaryButton
              text={rejectButtonText || 'Abbrechen'}
              variant={'outlined'}
              onButtonClick={props.onClose}
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              text={confirmButtonText || 'Ja'}
              customClasses={isDanger ? {root: classes.dangerButton} : undefined}
              onButtonClick={props.confirm}
              variant={isDanger ? 'outlined' : undefined}
            />
          </Grid>
        </Grid>
      }
    >
      <div className={clsx(classes.messageContent, customClasses.messageContent)}>
        {props.message}
      </div>
    </BaseDialog>
  )
}

export default withStyles(styles)(ConfirmationDialog);
